import { render, staticRenderFns } from "./Flasks.vue?vue&type=template&id=43510a46&"
import script from "./Flasks.vue?vue&type=script&lang=js&"
export * from "./Flasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports